/**
 * authTelemetry.js
 *
 * Thin, safe wrapper over Plausible for the auth journey, so we can SEE how users hit
 * Zoho's 10/10-min OAuth limit and test the stale-session hypothesis — without an
 * unauthenticated DataStore-write endpoint (which would be an abuse surface). Events:
 *
 *   SignInInitiated   — the Zoho widget was rendered (≈ one authorize round-trip begins)
 *   SignInThrottled   — our client guard blocked them (≈ they were in a retry storm)
 *   SignInDidNotStick — they returned from a sign-in attempt but /auth/me is still 401
 *                       (the smoking gun for "session not establishing" on mobile)
 *   AuthStaleSession  — localStorage said authenticated, but the server says 401
 *                       (a stale persisted/cookie session — the suspected cause)
 *   AuthCheckTimeout  — /auth/me did not respond in time (app would otherwise hang,
 *                       prompting a reload → more attempts)
 *
 * Never throws — analytics must never break the auth flow.
 */
export function track(event, props) {
  try {
    if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
      window.plausible(event, props ? { props } : undefined);
    }
  } catch (_) {
    /* analytics is best-effort */
  }
}
